import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms';
import { Crown } from '../../../../../common/icons/lucide-adapter';

export const PolicyFitBadgePremium = () => {
  return (
    <div className="mr-2 flex-1 rounded-lg border border-dashed border-gray-200 p-4 px-2 pt-2">
      <div className="mb-3 flex items-center justify-between gap-1">
        <h4 className="text-sm font-semibold text-stone-400">YOUR POLICY FIT</h4>
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Crown className={`d-6 rounded-full p-1 text-[#7F00FF]`} />
            </TooltipTrigger>
            <TooltipContent
              side="left"
              className="max-w-lg space-y-1 border border-gray-300 bg-white p-4 text-black shadow-sm"
            >
              <h3 className="text-sm font-semibold">YOUR POLICY FIT</h3>
              <p className="text-justify leading-relaxed">
                Easily check how a merchant aligns with your Acceptable Use Policy (AUP). Upload
                your AUP and automatically match the merchant's activities, products, and risk
                factors against your policy.
              </p>
              <p className="font-semibold">Examples:</p>
              <div className="overflow-hidden rounded-md border bg-gray-50">
                <div className="flex border-b border-gray-200">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Merchants selling unverified dietary supplements
                  </div>
                  <div className="flex w-20 items-center justify-center bg-orange-400/10">
                    <span className="text-xs text-orange-400">Restricted</span>
                  </div>
                </div>
                <div className="flex border-b border-gray-200">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Sale of historical artifacts in the UAE
                  </div>
                  <div className="flex w-20 items-center justify-center bg-red-500/10">
                    <span className="text-xs text-red-500">Prohibited</span>
                  </div>
                </div>
                <div className="flex border-b border-gray-200">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Marketing lead-generation services in Singapore
                  </div>
                  <div className="flex w-20 items-center justify-center bg-orange-400/10">
                    <span className="text-xs font-medium text-orange-400">Restricted</span>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-1 px-2 py-1 text-sm">
                    Travel booking services with flexible cancellations
                  </div>
                  <div className="flex w-20 items-center justify-center bg-green-500/10">
                    <span className="text-xs font-medium text-green-500">Neutral</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <a href="mailto:support@ballerine.com" className="mb-1 mt-3 text-sm font-semibold">
                  Talk to us to learn more
                </a>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <p className="mt-1 text-sm text-stone-400">
        Upload your acceptable use policy and let our AI underwriter determine how the merchant fits
        within it.
      </p>
    </div>
  );
};
